import topBtn from '../assets/images/go_top_btn.png';
import helpBtn from '../assets/images/help_btn.png';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SideMenu = () => {
    const location = useLocation();
    const [position, setPosition] = useState(window.innerHeight - 300); // 초기 하단 위치
    
    // share 경로인지 확인
    const isShareRoute = location.pathname.startsWith('/share');
    
    // 모바일 사이즈인지 확인
    const isMobile = window.innerWidth <= 768;

    useEffect(() => {
        // 스크롤 핸들러
        const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const scrollY = window.scrollY;
            setPosition(scrollY + windowHeight - 300); // 하단에서 100px 위
        };

        // 스크롤 이벤트 등록
        window.addEventListener('scroll', handleScroll);

        // 초기 실행
        handleScroll();

        // 클린업: 컴포넌트 언마운트 시 이벤트 제거
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(()=>{
        if(window.innerHeight+window.scrollY > document.body.scrollHeight){
            scrollTo(document.body.scrollHeight - window.innerHeight,'instant');
        }

    },[document.body.scrollHeight]);

    useEffect(() => {
        const scrollToTopButton = document.getElementById('scroll-to-top');
        const scrollToBottomButton = document.getElementById('scroll-to-bottom');
        const helpButton = document.getElementById('help-button');

        if (scrollToTopButton) {
            scrollToTopButton.addEventListener('click', scrollToTop);
        }

        if (scrollToBottomButton) {
            scrollToBottomButton.addEventListener('click', scrollToBottom);
        }

        if (helpButton) {
            helpButton.addEventListener('click', showHelpPopup);
        }

        return () => {
            if (scrollToTopButton) {
                scrollToTopButton.removeEventListener('click', scrollToTop);
            }
            if (scrollToBottomButton) {
                scrollToBottomButton.removeEventListener('click', scrollToBottom);
            }
            if (helpButton) {
                helpButton.removeEventListener('click', showHelpPopup);
            }
        };
    }, []);

    const scrollTo = (topPosition, behavior) => {
        window.scrollTo({
            top: topPosition,
            behavior: behavior? behavior:'smooth',
        });
    }

    // 스크롤 동작 함수
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
        });
    };

    const showHelpPopup = () => {
        window.open("https://1promath.notion.site/AI-174b8cfa9a12806491b8e4b82974d0dc?pvs=4", "_blank");
    };

    return (
        <div
            style={{
                position: 'absolute',
                top: `${position + (isShareRoute && isMobile ? 150 : 0)}px`, // share 모바일일 때 150px 더 아래로
                right: '20px', // 오른쪽에서 20px
                transition: 'top 0.4s ease', // 부드러운 이동 효과
            }}
            className="flex flex-col space-y-4 z-50"
        >
            <button
                id="scroll-to-top"
                className="flex items-center justify-end"
                aria-label="최상단으로 이동"
            >
                <img src={topBtn} alt="Top" className={isMobile ? "w-[40px]" : "w-[70px]"} draggable="false"/>
            </button>

            <button
                id="scroll-to-bottom"
                className="flex items-center justify-end"
                aria-label="최하단으로 이동"
            >
                <img
                    src={topBtn}
                    alt="Bottom"
                    className={isMobile ? "w-[40px] transform scale-y-[-1]" : "w-[70px] transform scale-y-[-1]"}
                    draggable="false"
                />
            </button>

            {!isShareRoute && (
                <button
                    id="help-button"
                    className="flex items-center justify-end"
                >
                    <img src={helpBtn} alt="Help" draggable="false"/>
                </button>
            )}
        </div>
    );
};

export default SideMenu;
